import { api } from "../../lib";
import type { AddendumMacro } from "../addendum.service";

export type AddendumMacroType = "addendum" | "amendment";

export interface AddendumMacroInput {
  name: string;
  shortcut: string | null;
  contentHtml: string;
  macroType: AddendumMacroType;
  isActive: boolean;
}

export const addendumMacrosService = {
  getAll: (macroType?: AddendumMacroType) =>
    api.get<AddendumMacro[]>(
      "/admin/addendum-macros",
      macroType ? { params: { macroType } } : undefined
    ),
  create: (input: AddendumMacroInput) =>
    api.post<AddendumMacro>("/admin/addendum-macros", input),
  update: (id: string, input: Partial<AddendumMacroInput>) =>
    api.put<AddendumMacro>(`/admin/addendum-macros/${id}`, input),
  delete: (id: string) => api.delete<void>(`/admin/addendum-macros/${id}`),
};
